/**
 * Acción de REDUX que permite terminar la sesión de un usuario 
 * No recibe parametros
 */

import { AUTH } from '../../../application/types';
import { logClient } from '../../lib/client_log';

/**
 * Exporta la función de logout
 */
export const logout = () => ( dispatch, state, firebase ) => {
  // Trace estructurado a Cloud Logging para detectar logouts automáticos
  // no deseados. Filtro en Logs Explorer: jsonPayload.event="auth.logout.triggered"
  const user = firebase().auth().currentUser;
  logClient({
    event: 'auth.logout.triggered',
    level: 'warn',
    message: 'dispatch(logout()) se ejecutó',
    data: {
      uid: user?.uid || null,
      email: user?.email || null,
      // Stack del caller — para saber QUIÉN disparó logout (botón onClick,
      // useEffect automático, etc.)
      callerStack: new Error('logout caller').stack,
    },
  });

  return firebase().auth().signOut()
    .then(
      () => dispatch({
        type: AUTH.LOGGINGOUT
      })
    )
    .catch(
      error => dispatch({
        type: AUTH.ERROR,
        code: error.code,
        message: error.message
      })
    )
}